import { IconTrophy, IconSwords, IconGift, IconX, IconArrowRight } from '../../components/icons.jsx';
import { ma } from './ArenaMedia.jsx';
import './ArenaBattleResult.css';

const OUTCOMES = {
  win: { title: 'Победа!', description: 'Отличный бой. Этот раунд за вами.', Icon: IconTrophy },
  loss: { title: 'Поражение', description: 'Каждый бой — шаг к следующей победе.', Icon: IconSwords },
  draw: { title: 'Ничья', description: 'Равный бой. Соперники достойны друг друга.', Icon: IconSwords },
};
const REWARDS = [
  { key: 'value', label: 'Кристаллы', image: '/assets/resource-emojis/crystal.webp' },
  { key: 'fragments', label: 'Фрагменты', image: '/assets/metapass-fragments-B9jWe72e.webp' },
  { key: 'eventCurrency', label: 'Валюта события', image: null },
];

/** @param {{ result: string, ratingDelta: number, rewards?: { value?: number, fragments?: number, eventCurrency?: number }, onViewBattle: () => void, onClose: () => void, onPlayAgain: () => void, busy?: boolean, error?: string }} props */
export function ArenaBattleResult({ result, ratingDelta, rewards = {}, onViewBattle, onClose, onPlayAgain, busy = false, error = '' }) {
  const { title, description, Icon } = OUTCOMES[result] || OUTCOMES.draw;
  const earned = REWARDS.filter(reward => (rewards[reward.key] ?? 0) > 0);
  return <section className={`arena-battle-result arena-battle-result-${result}`}>
    <button className="arena-battle-result-dismiss mc-icon-button" type="button" disabled={busy} onClick={onViewBattle} aria-label="Закрыть результат"><IconX aria-hidden="true" /></button>
    <div className="arena-battle-result-body">
    <header className="arena-battle-result-header">
      <div className="arena-battle-result-art" aria-hidden="true">
        <img src="/arena-matchmaking-halloween.webp" alt="" width="1254" height="1254" />
        <div className="arena-battle-result-embers"><i /><i /><i /><i /></div>
        <div className="arena-battle-result-emblem"><Icon /></div>
      </div>
      <span className="arena-battle-result-season">HALLOWEEN</span>
      <span className="arena-battle-result-eyebrow">БОЙ ЗАВЕРШЁН</span>
      <h2 id="battle-result-title">{title}</h2>
      <p>{description}</p>
    </header>
    <div className="arena-battle-result-rating">
      <span className="arena-battle-result-rating-icon" aria-hidden="true"><IconTrophy /></span>
      <span>Изменение рейтинга<small>{ratingDelta > 0 ? 'Ещё ближе к вершине' : ratingDelta < 0 ? 'В следующий раз получится' : 'Рейтинг сохранился'}</small></span>
      <b className={ratingDelta > 0 ? 'positive' : ratingDelta < 0 ? 'negative' : ''}>{ratingDelta > 0 ? '+' : ''}{ma(ratingDelta)}</b>
    </div>
    {earned.length > 0 && <section className="arena-battle-result-rewards" aria-label="Награды за бой">
      <h3>Награды за бой</h3>
      <div className="arena-battle-result-reward-grid" style={{ '--reward-count': earned.length }}>
        {earned.map(reward => <div className="arena-battle-result-reward" key={reward.key}>
          <span className="arena-battle-result-reward-icon" aria-hidden="true">{reward.image ? <img src={reward.image} alt="" width="32" height="32" /> : <IconGift />}</span>
          <b>+{ma(rewards[reward.key])}</b><span>{reward.label}</span>
        </div>)}
      </div>
    </section>}
    </div>
    <div className="arena-battle-result-actions">
      {error && <p className="arena-battle-result-error" role="alert">{error}</p>}
      <button className="arena-battle-result-primary" type="button" disabled={busy} onClick={onPlayAgain}>{busy ? 'Подключаем…' : 'Играть дальше'}<IconArrowRight aria-hidden="true" /></button>
      <button className="arena-battle-result-secondary" type="button" disabled={busy} onClick={onClose}>Выйти</button>
    </div>
  </section>;
}
